<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        {{this.ReportTypes[this.ReportIndex].Name}} - {{this.Filter.EmpType}}
    </div>
    <div class="card-body">
        <form class="g-3" name="ReportForm" #ReportForm="ngForm" novalidate>
            <div class="row m-1">
                <div class="px-1"
                    [ngClass]="{'col-md-2':this.common.ToLowerCase(this.Filter.EmpType) == 'front','col-md-4':this.common.ToLowerCase(this.Filter.EmpType) == 'back'}"
                    *ngIf="Filter.SelectType === 'ReimbursementReport'">
                    <label for="Reimbursementtype" class="form-font-label">Reimbursement Type<span
                            class="text-danger">*</span></label>
                    <ng-select name="Reimbursementtype" [items]="ReimbursementLoad" bindLabel="ReimbursementType"
                        bindValue="ESS_ReimbursementTypeID" [(ngModel)]="this.Filter.ESS_ReimbursementTypeId"
                        placeholder="All">
                    </ng-select>
                </div>
                <div class="px-1"
                    [ngClass]="{'col-md-2':this.common.ToLowerCase(this.Filter.EmpType) == 'front','col-md-4':this.common.ToLowerCase(this.Filter.EmpType) == 'back'}"
                    *ngIf="Filter.SelectType === 'ReimbursementReport'">
                    <label for="Financialyear" class="form-font-label">Financial Year<span
                            class="text-danger">*</span></label>
                    <ng-select name="Financialyear" [items]="YearLoad" bindLabel="YearRange" bindValue="YearRange"
                        [(ngModel)]="this.Filter.FinancialYear" placeholder="All">
                    </ng-select>
                </div>
                <div class="col-md-4 px-1"
                    *ngIf="Filter.SelectType !== 'ReimbursementReport' && Filter.SelectType !== 'EmployeeDurationReport' && Filter.SelectType !== 'MISReport' && Filter.SelectType !== 'MusterAttendancePOCMailReport'">
                    <label for="FromDateObj" class="form-font-label"> {{ReportTypes[ReportIndex].FromDateLabel??'From Date'}}<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-4 px-1"
                    *ngIf="ReportTypes[ReportIndex].ShowToDate??true && Filter.SelectType !== 'ReimbursementReport' && Filter.SelectType !== 'EmployeeDurationReport' && Filter.SelectType !== 'MISReport' && Filter.SelectType !== 'MusterAttendancePOCMailReport'">
                    <label for="ToDateObj" class="form-font-label">To Date<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>

                <div class="col-md-6 px-1" *ngIf="Filter.SelectType == 'EmployeeDurationReport' || Filter.SelectType == 'MusterAttendancePOCMailReport'">
                    <label for="FromDateObj" class="form-font-label"> Month Year </label>
                    <div class="input-group">
                        <ngb-datepicker #dp name="monthyear" [(ngModel)]="Filter.MonthName"
                            class="month-year small-datepicker"
                            (navigate)="Filter.MonthName= $event.next;onNavigate($event)"></ngb-datepicker>
                    </div>
                    <div class="invalid-feedback">
                        Please select Month and Year!
                    </div>
                </div>

                <div class="col-md-5 px-1" *ngIf="Filter.SelectType == 'MISReport'">
                    <label class="form-font-label"> Report Type <span class="text-danger">*</span> </label>
                    <ng-select name="reporttype" [items]="MISReportType" bindLabel="ReportName" bindValue="ReportName"
                        [(ngModel)]="Filter.MISReportType" placeholder="Select Report Type">
                    </ng-select>
                </div>

                <div class="col-auto px-1" *ngIf="Filter.SelectType == 'MISReport'">
                    <label class="form-font-label"> From Month Year </label>
                    <div class="input-group">
                        <ngb-datepicker #dp name="monthyear" [(ngModel)]="Filter.FromMonth"
                            class="month-year small-datepicker"
                            (navigate)="Filter.FromMonth= $event.next;onNavigate($event)"></ngb-datepicker>
                    </div>
                    <div class="invalid-feedback">
                        Please select Month and Year!
                    </div>
                </div>

                <div class="col-auto px-1" *ngIf="Filter.SelectType == 'MISReport'">
                    <label class="form-font-label"> To Month Year </label>
                    <div class="input-group">
                        <ngb-datepicker #dp name="monthyear" [(ngModel)]="Filter.ToMonth"
                            class="month-year small-datepicker"
                            (navigate)="Filter.ToMonth= $event.next;onNavigate($event)"></ngb-datepicker>
                    </div>
                    <div class="invalid-feedback">
                        Please select Month and Year!
                    </div>
                </div>


                <div class="col-md-4 px-1"
                    *ngIf="(ReportTypes[ReportIndex].ShowApprovalType??true) && Filter.SelectType !== 'EmployeeDurationReport' && Filter.SelectType !== 'MISReport' && Filter.SelectType !== 'MusterAttendancePOCMailReport'">
                    <label for="ApprovalStatus" class="form-font-label">Approval Type<span
                            class="text-danger">*</span></label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required required>
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select approval type!
                    </div>
                </div>
            </div>

            <div class="row m-1">
                <div class="px-1 col-md-4"
                    *ngIf="(Filter.SelectType !== 'ReimbursementReport' || Filter.SelectType == 'EmployeeDurationReport')">
                    <label for="Branch" class="form-font-label">Branch <span *ngIf="Filter.SelectType == 'EmployeeDurationReport'" class="text-danger">*</span></label>
                    <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client')" placeholder="All">
                    </ng-select>
                </div>
                <div class="col-md-4 px-1"
                    *ngIf="(this.common.ToLowerCase(this.Filter.EmpType) == 'front') && (Filter.SelectType !== 'ReimbursementReport')">
                    <label for="Client" class="form-font-label">Client</label>
                    <ng-select name="Client" [items]="Clients" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site')"
                        placeholder="All">
                    </ng-select>
                </div>
                <div class="col-md-4 px-1"
                    *ngIf="(this.common.ToLowerCase(this.Filter.EmpType) == 'front') && Filter.SelectType !== 'ReimbursementReport'">
                    <label for="Site" class="form-font-label">Site</label>
                    <ng-select name="Site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteId" placeholder="All">
                    </ng-select>
                </div>
            </div>

            <div class="row m-1">
                <div class="col-md-4 px-1"
                    *ngIf="(this.common.ToLowerCase(this.Filter.EmpType) == 'front' || this.common.ToLowerCase(this.Filter.EmpType) == 'back') && Filter.SelectType !== 'ReimbursementReport' && Filter.SelectType == 'OutdoorReport'">
                    <label for="EmployeeCode" class="text-label-dark">Employee Code</label>
                    <input type="text" class="form-control" placeholder="Ex. 001" id="EmployeeCode" name="EmployeeCode"
                        [(ngModel)]="Filter.EmpCode" #EmployeeCode="ngModel" maxlength="25">
                </div>
                <!-- <div class="col-auto px-1 mt-4">
                    <button type="submit" *ngIf="this.common.PageRight.IsPrint" class="btn btn-primary btn-sm"
                        [disabled]="isDisabled"><i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>
                </div> -->
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button (click)="Download()" type="button" *ngIf="this.common.PageRight.IsPrint"
                class="btn btn-primary btn-sm" [disabled]="isDisabled"><i
                    [class]="Filter.SelectType == 'EmployeeDurationReport' ? 'bi bi-file-earmark-pdf' : 'bi bi-file-earmark-arrow-down'"
                    *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled? Filter.SelectType == 'EmployeeDurationReport' ? 'Pdf' : 'Excel':'Loading...'}}</button>

            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>